import { camps } from 'api';
import {
  SET_CAMPS_PROPERTY,
  CAMPS_GET_MASTER_DATA,
  CAMPS_UPDATE_MASTER_DATA,
  CAMPS_GET_CARS,
  CAMPS_GET_CAR_DETAIL,
  CAMPS_UPDATE_KM,
  CAMPS_GET_CAR_ACCESSORIES,
  CAMPS_UPDATE_TASK_STATE,
  CAMPS_GET_TASKS,
  CAMPS_GET_TASK_DETAIL,
  CAMPS_GET_PAPS,
  CAMPS_GET_PAP_DETAIL,
  CAMPS_SAVE_DETAIL_PAP,
  CAMPS_TRANSPORT_EMPLOYEES_GET_LIST,
  CAMPS_TRANSPORT_MANAGERS_GET_LIST,
  CAMPS_GET_DISCREPANCIES
} from 'store/actions/camps';
import { userPartnerId } from 'helpers/user';
import { paginationData } from 'helpers/store';
import { ensureTyreProperties } from 'helpers/object';

export default {
  [SET_CAMPS_PROPERTY]: ({ commit }, { field, value }) =>
    commit(SET_CAMPS_PROPERTY, { field, value }),

  [CAMPS_GET_MASTER_DATA]: ({ commit, getters }) =>
    new Promise((resolve, reject) => {
      if (!getters.hasCampsMasterData) {
        camps
          .getMasterData()
          .then(resp => {
            commit(CAMPS_UPDATE_MASTER_DATA, resp.data);
            const idPartner = userPartnerId();
            if (!idPartner) resolve(null);

            const storagePark = resp.data.storageParks.filter(
              storage => storage.idParent === idPartner
            )[0];

            resolve(storagePark);
          })
          .catch(err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          });
      } else {
        resolve();
      }
    }),

  [CAMPS_GET_CARS]: ({ state, commit }) =>
    new Promise((resolve, reject) => {
      if (!state.carListFilters.idStoragePark && !state.carListFilters.plate) resolve();
      const filters = {
        plate: state.carListFilters.plate,
        startDate: state.carListFilters.startDate,
        endDate: state.carListFilters.endDate,
        idStoragePark: state.carListFilters.idStoragePark,
        idState: state.carListFilters.idState,
        idCategory: state.carListFilters.idCategory
      };
      camps.getCarList(filters).then(
        resp => {
          commit(SET_CAMPS_PROPERTY, {
            field: 'carList',
            value: resp.data
          });
          resolve();
        },
        err => {
          // commit('ERROR_OCCURRED', err, { root: true });
          reject(err.response.data.error);
        }
      );
    }),

  [CAMPS_GET_CAR_DETAIL]: ({ dispatch, commit }, plate) =>
    new Promise((resolve, reject) => {
      camps.getCarDetail(plate).then(
        resp => {
          const carDetail = resp.data;
          commit(SET_CAMPS_PROPERTY, {
            field: 'carDetail',
            value: carDetail
          });
          dispatch(CAMPS_GET_CAR_ACCESSORIES, plate);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [CAMPS_GET_CAR_ACCESSORIES]: ({ commit }, plate) =>
    new Promise((resolve, reject) => {
      camps.getAccessories(plate).then(
        resp => {
          const carAccessories = resp.data;
          commit(SET_CAMPS_PROPERTY, {
            field: 'carAccessories',
            value: carAccessories
          });
          resolve();
        },
        err => {
          reject(err.response.data.error);
        }
      );
    }),

  [CAMPS_UPDATE_KM]: (_, { plate, km }) =>
    new Promise((resolve, reject) => {
      camps.setKms(plate, km).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data.error);
        }
      );
    }),

  [CAMPS_GET_TASKS]: ({ state, commit }) =>
    new Promise((resolve, reject) => {
      if (!state.taskListFilter.idStoragePark && !state.taskListFilter.plate && !state.idPap)
        resolve();
      const filters = {
        plate: state.taskListFilter.plate,
        startDate: state.taskListFilter.startDate,
        endDate: state.taskListFilter.endDate,
        idStoragePark: state.taskListFilter.idStoragePark,
        idTaskStatus: state.taskListFilter.idTaskStatus,
        idTaskTypes: state.taskListFilter.idTaskTypes,
        idPap: state.taskListFilter.idPap
      };
      camps.getTasks(filters).then(
        resp => {
          commit(SET_CAMPS_PROPERTY, {
            field: 'taskList',
            value: resp.data
          });
          resolve();
        },
        err => {
          reject(err.response.data.error);
        }
      );
    }),

  [CAMPS_UPDATE_TASK_STATE]: ({ commit }, { idTask, idTaskStatus }) =>
    new Promise((resolve, reject) => {
      camps.setTaskState(idTask, idTaskStatus).then(
        () => {
          commit(CAMPS_UPDATE_TASK_STATE, { idTask, idTaskStatus });
          resolve();
        },
        err => {
          reject(err.response.data.error);
        }
      );
    }),

  [CAMPS_GET_TASK_DETAIL]: ({ state, commit }, plate) =>
    new Promise((resolve, reject) => {
      if (!plate) resolve();
      const filters = {
        plate,
        idTaskTypes: state.taskFilter.idTaskTypes,
        idTaskStatus: state.taskFilter.idTaskStatus,
        startDate: state.taskFilter.startDate,
        endDate: state.taskFilter.endDate
      };
      camps.getTasks(filters).then(
        resp => {
          commit(SET_CAMPS_PROPERTY, {
            field: 'carTasks',
            value: resp.data
          });
          resolve();
        },
        err => {
          reject(err.response.data.error);
        }
      );
    }),

  [CAMPS_GET_PAPS]: ({ state, commit }) =>
    new Promise((resolve, reject) => {
      if (!state.papsFilter.idStoragePark) resolve();
      const filters = {
        idStoragePark: state.papsFilter.idStoragePark,
        idState: state.papsFilter.idState,
        plate: state.papsFilter.plate,
        offset: state.papsFilter.offset,
        limit: state.papsFilter.limit,
        sortType: state.papsFilter.sortType
      };
      camps.getPaps(filters).then(
        resp => {
          commit(SET_CAMPS_PROPERTY, {
            field: 'paps',
            value: {
              items: resp.data,
              totalItems: paginationData(resp).total
            }
          });
          resolve();
        },
        err => {
          reject(err.response.data.error);
        }
      );
    }),

  [CAMPS_GET_PAP_DETAIL]: ({ commit }, { id }) =>
    new Promise((resolve, reject) => {
      camps.getPapDetail(id).then(
        resp => {
          const papDetail = ensureTyreProperties({
            data: resp.data,
            insideVariable: false
          });
          commit(SET_CAMPS_PROPERTY, {
            field: 'papDetail',
            value: papDetail
          });
          camps.getTasks({ idPap: id }).then(
            respTasks => {
              commit(SET_CAMPS_PROPERTY, {
                field: 'papsAssociatedTasksList',
                value: respTasks.data
              });
              resolve();
            },
            err => {
              reject(err.response.data.error);
            }
          );
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [CAMPS_SAVE_DETAIL_PAP]: (_, data) =>
    new Promise((resolve, reject) => {
      camps.saveDetailPap(data).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data.error);
        }
      );
    }),

  [CAMPS_TRANSPORT_EMPLOYEES_GET_LIST]: ({ state, commit }) =>
    new Promise((resolve, reject) => {
      const filters = {
        idStoragePark: state.transportEmployeesListFilters.idStoragePark,
        idProvider: state.transportEmployeesListFilters.idProvider,
        plate: state.transportEmployeesListFilters.plate,
        idState: state.transportEmployeesListFilters.idState,
        idType: state.transportEmployeesListFilters.idType
      };
      camps.getTransportationList(filters).then(
        resp => {
          commit(SET_CAMPS_PROPERTY, {
            field: 'transportList',
            value: resp.data
          });
          resolve();
        },
        err => {
          // commit('ERROR_OCCURRED', err, { root: true });
          reject(err.response.data.error);
        }
      );
    }),

  [CAMPS_TRANSPORT_MANAGERS_GET_LIST]: ({ state, commit }) =>
    new Promise((resolve, reject) => {
      userPartnerId()
        .then(idPartner => {
          const idStoragePark = state.storageParks?.filter(
            storage => storage.idParent === idPartner
          )[0]?.id;
          if (idStoragePark) {
            const filters = {
              idProvider: state.transportManagerListFilters.idProvider,
              plate: state.transportManagerListFilters.plate,
              idState: state.transportManagerListFilters.idState,
              idType: state.transportManagerListFilters.idType,
              idStoragePark
            };
            camps.getTransportationList(filters).then(
              resp => {
                commit(SET_CAMPS_PROPERTY, {
                  field: 'transportList',
                  value: resp.data
                });
                resolve();
              },
              err => {
                // commit('ERROR_OCCURRED', err, { root: true });
                reject(err.response.data.error);
              }
            );
          } else {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject('Error al obtener el id de la campa del conductor');
          }
        })
        .catch(err => {
          reject(err.response.data.error);
        });
    }),

  [CAMPS_GET_DISCREPANCIES]: ({ commit }, { idTransport }) =>
    new Promise((resolve, reject) => {
      camps.getDiscrepancies(idTransport).then(
        resp => {
          commit(SET_CAMPS_PROPERTY, {
            field: 'discrepanciesList',
            value: resp.data
          });
          resolve();
        },
        err => {
          reject(err.response.data.error);
        }
      );
    })
};
